import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { format } from 'date-fns';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { TrackingFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './distribution.actions';

@Injectable()
export class DistributionEffects {
    actions$ = inject(Actions);
    api = inject(DealerApiService);
    store = inject(Store);

    submitTestDriveForm$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitTestDriveForm),
            switchMap((action) =>
                from(this.api.postTestDriveForm(action.payload)).pipe(
                    switchMap(() => {
                        return [
                            actions.submitDistributionFormResponse({ success: true }),
                            TrackingFeature.actions.formTestDriveSubmitTracking({
                                form: {
                                    comment: action.payload.message ?? '',
                                    date: action.payload.wishDate ? format(action.payload.wishDate, 'yyyy-MM-dd') : '',
                                    day: action.payload.wishDate ? format(action.payload.wishDate, 'EEEE') : '',
                                    time: action.payload.wishTime ?? '',
                                },
                                vehicle: action.vehicle,
                            }),
                        ];
                    }),
                    catchError(() => {
                        return of(actions.submitDistributionFormResponse({ success: false }));
                    }),
                ),
            ),
        );
    });

    submitGeneralRequestForm$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitGeneralRequestForm),
            switchMap((action) =>
                from(this.api.postGeneralRequestForm(action.payload)).pipe(
                    switchMap(() => {
                        return [
                            actions.submitDistributionFormResponse({ success: true }),
                            TrackingFeature.actions.formGeneralRequestSubmitTracking({
                                form: {
                                    comment: action.payload.message ?? '',
                                },
                                vehicle: action.vehicle,
                            }),
                        ];
                    }),
                    catchError(() => {
                        return of(actions.submitDistributionFormResponse({ success: false }));
                    }),
                ),
            ),
        );
    });

    submitReservationForm$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitReservationForm),
            switchMap((action) =>
                from(this.api.postReservationForm(action.payload)).pipe(
                    switchMap(() => {
                        return [
                            actions.submitDistributionFormResponse({ success: true }),
                            TrackingFeature.actions.formReservationSubmitTracking({
                                vehicle: action.vehicle,
                            }),
                        ];
                    }),
                    catchError(() => {
                        return of(actions.submitDistributionFormResponse({ success: false }));
                    }),
                ),
            ),
        );
    });

    submitDistributionFormLoading$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitTestDriveForm, actions.submitGeneralRequestForm, actions.submitReservationForm),
            map(() => {
                return actions.submitDistributionFormLoading({ loading: true });
            }),
        );
    });
}
